import { render, staticRenderFns } from "./Orase.vue?vue&type=template&id=11b1a926"
import script from "./Orase.vue?vue&type=script&lang=js"
export * from "./Orase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports